import mergeStyleProps from '@lib/utils/styles/mergeStyleProps';
import React from 'react';
import { useTheme } from 'styled-components';

interface ActionCardIconLeftProps extends React.SVGProps<SVGSVGElement> {
  Icon: (p: React.SVGProps<SVGSVGElement>) => JSX.Element;
}

const ActionCardIconLeft: React.FunctionComponent<ActionCardIconLeftProps> = (props) => {
  const { Icon, style, className, color } = props;
  const theme = useTheme();

  return (
    <Icon
      width={32}
      height={32}
      color={color ?? theme.color.tint.action}
      style={mergeStyleProps({ marginLeft: 16, marginRight: 12, alignSelf: 'center' }, style)}
      className={className}
    />
  );
};

export default ActionCardIconLeft;
